
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {CategoryModel} from '@/models/category.model';
  import CategoriesHeader from './CategoriesHeader.vue';
  import CategoriesList from './CategoriesList.vue';
  import CategoriesBody from './CategoriesBody.vue';
  import CategoriesAmbassador from './CategoriesAmbassador.vue';
  import CategoriesChallenges from './CategoriesChallenges.vue';
  import {categoriesModule, categoriesState} from '@/utils/store-acessor';
  import Footer from '@/components/Footer.vue';
  import {Watch} from 'vue-property-decorator';
  import {Route} from 'vue-router';

  @Component({
    components: {
      CategoriesHeader,
      CategoriesList,
      CategoriesBody,
      CategoriesAmbassador,
      CategoriesChallenges,
      Footer,
    },
    metaInfo() {
      // @ts-ignore
      const {name, description} = this.selectedCategory || {};
      return ({
        title: name ? `${name} - Ikone` : 'Categories - Ikone',
        metas: [{vmid: 'description', name: 'description', content: `${description}`}],
      })
    },
  })
  export default class Categories extends Vue {
    selectedCategory: CategoryModel | null = null;
    @categoriesModule.Getter('activeCategories') categories!: CategoryModel[];
    @categoriesModule.Getter('loading') loading!: boolean[];
    @categoriesModule.Getter('getCategoryBySlug') categoryBySlug!: (slug: string) => CategoryModel | null;

    async mounted() {
      await categoriesState.fetchActiveCategories();
      const slug = this.$route.params.categorySlug;
      if (!slug && this.categories) {
        this.selectedCategory = this.categories[0];
        if (this.categories[0]?.slug) {
          await this.$router.replace(`/categories/${this.categories[0].slug}`);
        }
      } else {
        this.selectCategory(slug);
      }
    }

    get hasAmbassador(): boolean {
      const lengthDescription = this.selectedCategory?.ambassador_description?.length || 0;
      const lengthName = this.selectedCategory?.ambassador_name?.length || 0;
      return lengthDescription > 0 && lengthName > 0
    }

    @Watch('$route')
    onRouteChange(v: Route) {
     if (v.name === 'category-with-slug') {
       const slug = this.$route.params.categorySlug;
       this.selectCategory(slug)
     }
    }

    async selectCategory(slug: string) {
      const category = await this.categoryBySlug(slug);
      this.selectedCategory = category || null;
    }
  }

